export default __webpack_public_path__ + "static/media/image-sample-provider-photo.8685c5a0.png";